import React from "react";
import { useCommentsContext } from "../../context/CommentsContext";
import { useQuestionsContext } from "../../context/QuestionsContext";
import { usePollsContext } from "../../context/PollsContext";
import ButtonQuestionWriteFormWrapper from "../../components/QuestionMessages/ButtonQuestionWriteFormWrapper";
import ButtonQuestionWriteForm from "../../components/SideModule/ButtonQuestionWriteForm";
import './style.scss';

export default ({ settings }) => {
    const { enabled: commentsEnabled } = useCommentsContext();
    const { isShowBlockQuestions: questionsEnabled, isAvailableReceivingQuestions } = useQuestionsContext();
    const { enabled: pollsEnabled } = usePollsContext();
    const isEnabledSideModule = commentsEnabled || questionsEnabled || pollsEnabled;

    if (isEnabledSideModule || !isAvailableReceivingQuestions) return null;

    return (
        <section className={"question-button-block"}>
            <ButtonQuestionWriteFormWrapper
                settings={settings}
                ButtonComponent={ButtonQuestionWriteForm}
            />
        </section>
    );
}
